export enum AlertEnums {
    importAddSuccess = 'import.add.success',
    importUpdateSuccess = 'import.update.success',
    importDeleteSuccess = 'import.delete.success',
    importEditError = 'import.edit.error',
    importGetSuccess = 'import.get.success',
    companyAddSuccess = 'company.add.success',
    companyUpdateSuccess = 'company.update.success',
    companyApproveSuccess = 'company.approve.success',
    companyDeleteSuccess = 'company.delete.success',
    companyRestoreSuccess = 'company.restore.success',
    companyEditError = 'company.edit.error',
    companyGetSuccess = 'company.get.success',
    groupAddSuccess = 'group.add.success',
    groupUpdateSuccess = 'group.update.success',
    groupDeleteSuccess = 'group.delete.success',
    groupEditError = 'group.edit.error',
    groupGetSuccess = 'group.get.success',
    orderAddSuccess = 'order.add.success',
    orderUpdateSuccess = 'order.update.success',
    orderDeleteSuccess = 'order.delete.success',
    orderEditError = 'order.edit.error',
    orderGetSuccess = 'order.get.success',
    quotationAddSuccess = 'quotation.add.success',
    quotationEditDraftSuccess = 'quotation.edit.draft.success',
    sendQuotationSuccess = 'quotation.send.success',
    acceptQuotationSuccess = 'quotation.accept.success',
    quotationAprovedSuccess = 'quotation.aproved.success',
    quotationDraftAddSuccess = 'quotation.add.draft.success',
    quotationUpdateSuccess = 'quotation.update.success',
    quotationPromptToOrderSuccess = 'quotation.prompt_to_order.success',
    quotationPromptToOrderError = 'quotation.prompt_to_order.error',
    quotationErpPushErrorTitle = 'quotation.erp_push.error.title',
    quotationErpPushErrorHint = 'quotation.erp_push.error.hint',
    quotationDeleteSuccess = 'quotation.delete.success',
    quotationEditError = 'quotation.edit.error',
    quotationCancelSuccess = 'quotation.cancel.success',
    quotationGetSuccess = 'quotation.get.success',
    quotationDuplicateSuccess = 'quotation.duplicate.success',
    quotationArchiveSuccess = 'quotation.archive.success',
    quotationRestoreSuccess = 'quotation.restore.success',
    segmentAddSuccess = 'segment.add.success',
    segmentUpdateSuccess = 'segment.update.success',
    segmentDeleteSuccess = 'segment.delete.success',
    segmentEditError = 'segment.edit.error',
    segmentGetSuccess = 'segment.get.success',
    productAddSuccess = 'product.add.success',
    productUpdateSuccess = 'product.update.success',
    productDeleteSuccess = 'product.delete.success',
    productDeleteError = 'product.delete.error',
    productEditError = 'product.edit.error',
    productGetSuccess = 'product.get.success',
    catalogAddSuccess = 'catalog.add.success',
    catalogAddError = 'catalog.add.error',
    catalogUpdateSuccess = 'catalog.update.success',
    catalogDeleteSuccess = 'catalog.delete.success',
    catalogDeleteError = 'catalog.delete.error',
    catalogEditError = 'catalog.edit.error',
    catalogGetSuccess = 'catalog.get.success',
    brandAddSuccess = 'brand.add.success',
    brandUpdateSuccess = 'brand.update.success',
    brandDeleteSuccess = 'brand.delete.success',
    brandEditError = 'brand.edit.error',
    brandGetSuccess = 'brand.get.success',
    categoryAddSuccess = 'category.add.success',
    categoryUpdateSuccess = 'category.update.success',
    categoryDeleteSuccess = 'category.delete.success',
    categoryEditError = 'category.edit.error',
    categoryGetSuccess = 'category.get.success',
    tagAddSuccess = 'tag.add.success',
    tagUpdateSuccess = 'tag.update.success',
    tagDeleteSuccess = 'tag.delete.success',
    tagEditError = 'tag.edit.error',
    tagGetSuccess = 'tag.get.success',
    userAddSuccess = 'user.add.success',
    userUpdateSuccess = 'user.update.success',
    userDeleteSuccess = 'user.delete.success',
    userEditError = 'user.edit.error',
    userGetSuccess = 'user.get.success',
    roleAddSuccess = 'role.add.success',
    roleUpdateSuccess = 'role.update.success',
    roleDeleteSuccess = 'role.delete.success',
    roleEditError = 'role.edit.error',
    deleteEditError = 'role.delete.error',
    roleGetSuccess = 'role.get.success',
    teamAddSuccess = 'team.add.success',
    teamUpdateSuccess = 'team.update.success',
    teamDeleteSuccess = 'team.delete.success',
    teamEditError = 'team.edit.error',
    teamDeleteError = 'team.delete.error',
    labelAddSuccess = 'label.add.success',
    labelUpdateSuccess = 'label.update.success',
    labelDeleteSuccess = 'label.delete.success',
    comparatorAddSuccess = 'comparator.add.success',
    comparatorUpdateSuccess = 'comparator.update.success',
    comparatorDeleteSuccess = 'comparator.delete.success',
    comparatorEditError = 'comparator.edit.error',
    comparatorGetSuccess = 'comparator.get.success',
    notificationAddSuccess = 'notification.add.success',
    notificationUpdateSuccess = 'notification.update.success',
    notificationDeleteSuccess = 'notification.delete.success',
    notificationEditError = 'notification.edit.error',
    catalogShareSuccess = 'catalog.share.success',
    catalogShareError = 'catalog.share.error',
    agentAddSuccess = 'agent.add.success',
    agentUpdateSuccess = 'agent.update.success',
    agentDeleteSuccess = 'agent.delete.success',
    agentsDeleteSuccess = 'agents.delete.success',
    agentEditError = 'agent.edit.error',
    agentGetSuccess = 'agent.get.success',
    invitationResendSuccess = 'invitation_resend_success',
    invitationResendError = 'invitation_resend_error',
    quotationEditSuccess = 'quotation.edit.success',
    quotationUpdateEmailSuccess = 'quotation.update.email.success',
    customFieldAddSuccess = 'custom_field.add.success',
    customFieldUpdateSuccess = 'custom_field.update.success',
    customFieldDeleteSuccess = 'custom_field.delete.success',
    locationUpdateSuccess = 'location.update.success',
    contactAddSuccess = 'contact.add.success',
    contactAddError = 'contact.add.error',
    contactUpdateSuccess = 'contact.update.success',
    contactUpdateError = 'contact.update.error',
    contactDeleteSuccess = 'contact.delete.success',
    contactDeleteError = 'contact.delete.error',
  }
  export enum AlertEnums {
    addSuccess = "The item has been created successfully",
    updateSuccess = "The item has been updated successfully",
    EditError = "An error occurred, please try again later",
    deleteSuccess = "The item has been deleted successfully",
    getSuccess = "The data has been retrieved successfully",
  }

  export enum ToastMessages {
    CredentialsError = 'CREDENTIALS_ERROR',
    PasswordResetEmailSent = 'PASSWORD_RESET_EMAIL_SENT',
    PasswordResetError = 'PASSWORD_RESET_ERROR',
    PasswordResetSuccess = 'PASSWORD_RESET_SUCCESS',
    PasswordResetFailed = 'PASSWORD_RESET_FAILED',
  }

